import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAccessibility$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAccessibility extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-accessibility", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M8.79791 4.40002C8.79791 4.91296 9.11973 5.35073 9.57248 5.52243C9.8519 5.59041 10.1437 5.59044 10.4231 5.52251C10.876 5.35087 11.1979 4.91304 11.1979 4.40002C11.1979 3.73727 10.6607 3.20001 9.99792 3.20001C9.33517 3.20001 8.79791 3.73727 8.79791 4.40002ZM7.61892 4.71903C7.60505 4.61466 7.5979 4.50818 7.5979 4.40002C7.5979 3.07452 8.67243 2 9.99792 2C11.3234 2 12.3979 3.07452 12.3979 4.40002C12.3979 4.5082 12.3908 4.6147 12.3769 4.71909L14.6781 3.74228C15.5926 3.35409 16.6524 3.77778 17.0473 4.68943C17.4435 5.60423 17.0201 6.6633 16.1024 7.05283L13.2 8.28486V11.2586L14.6995 15.6135C15.0231 16.5534 14.5235 17.5778 13.5835 17.9014C12.6436 18.2251 11.6192 17.7255 11.2956 16.7855L9.99805 13.0173L8.7006 16.7853C8.37695 17.7253 7.35259 18.2249 6.41263 17.9013C5.47267 17.5776 4.97306 16.5533 5.29671 15.6133L6.79991 11.2477V8.28652L3.89351 7.05283C2.97584 6.6633 2.55244 5.60423 2.94867 4.68943C3.34354 3.77778 4.40332 3.35409 5.31784 3.74228L7.61892 4.71903ZM9.21556 6.66963C9.08346 6.63394 8.95321 6.58905 8.82578 6.53496L4.84896 4.8469C4.54135 4.71633 4.18264 4.85973 4.04983 5.16638C3.91837 5.46988 4.05794 5.81898 4.36239 5.94822L7.39064 7.23363C7.76004 7.39043 7.99992 7.75285 7.99992 8.15414V11.2812C7.99992 11.392 7.98151 11.502 7.94544 11.6067L6.43134 16.004C6.32346 16.3173 6.48999 16.6587 6.80332 16.7666C7.11664 16.8745 7.45809 16.708 7.56597 16.3947L9.25264 11.4962C9.49706 10.7858 10.5 10.7886 10.7434 11.496L12.4302 16.3948C12.5381 16.7082 12.8795 16.8747 13.1928 16.7668C13.5062 16.6589 13.6727 16.3175 13.5648 16.0042L12.0544 11.6177C12.0184 11.5129 11.9999 11.4029 11.9999 11.2921V8.15249C11.9999 7.7512 12.2398 7.38877 12.6092 7.23197L15.6336 5.94822C15.938 5.81898 16.0776 5.46988 15.9461 5.16638C15.8133 4.85973 15.4546 4.71633 15.147 4.8469L11.1702 6.53496C11.0426 6.58913 10.9121 6.63407 10.7798 6.66978C10.5347 6.7542 10.2717 6.80004 9.99792 6.80004C9.72399 6.80004 9.46078 6.75415 9.21556 6.66963Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-accessibility-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-accessibility", "wpp-icon-accessibility-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-accessibility-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-accessibility-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAccessibility$1);
      }
      break;
  } });
}

const WppIconAccessibility = WppIconAccessibility$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAccessibility, defineCustomElement };
